export const ListMagnifyingGlass = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2909_54458)">
        <path
          d="M12.5 20H67.5"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 40H35"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 60H40"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.5 55C63.0228 55 67.5 50.5228 67.5 45C67.5 39.4772 63.0228 35 57.5 35C51.9772 35 47.5 39.4772 47.5 45C47.5 50.5228 51.9772 55 57.5 55Z"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.5703 52.0723L72.4984 60.0004"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2909_54458">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
